module.exports = __webpack_public_path__ + "aff_logo_white.png?b944b2e81da5ec357759c674682e9a9b";